export default __webpack_public_path__ + "static/media/luctu.5d939d06.png";